import { connect } from 'react-redux'
import AddShipping from './view'

export default connect(null, {})(AddShipping)
